import { IRichTextEditorDefaultStyleValues } from 'src/components/widget/richTextWidget/RichTextWidget.interface';
import { IThemeRes, ProjectConfigInterface } from 'src/interfaces';

export const useRteDefaultStyleValues = (
  theme?: IThemeRes,
  projectConfig?: Partial<ProjectConfigInterface>,
): IRichTextEditorDefaultStyleValues => {
  const activeThemeKey = projectConfig?.activeTheme;
  const activeTheme = activeThemeKey
    ? projectConfig?.themes?.[activeThemeKey]
    : undefined;
  const resolvedFont = theme?.config?.font ?? activeTheme?.font;
  const resolvedColor = theme?.config?.color ?? activeTheme?.color;

  return {
    ...(resolvedFont && { fontFamily: resolvedFont }),
    ...(resolvedColor && { color: resolvedColor }),
  };
};
